<template>

  <scroll-menu :spaceEven="false">
    
      <gallery-image @click.native='removePhoto(index)' v-for="(media,index) in computeMedias" :key="media.url" :media="media" :index="index" :total="computeMedias.length"/>
   
  </scroll-menu>
  
</template>

<script>

import ScrollMenu from "../scrollMenu/ScrollMenu.vue";
import GalleryImage from "./GalleryImage.vue";

import { modalService } from '../../services/ModalService.js';
import i18n from "../../language.js";

export default {
  name: 'upload-gallery',
  props:{
    medias:{
      type:Array,
      default:()=>{[]},
    },
  },
  data(){
    return {
      //data_medias:[],
      updateKey:0,
    }
  },
  components: {
    ScrollMenu,
    GalleryImage,
  },
  computed:{
    computeMedias(){
      return this.medias;
    },
  },
  methods:{
    
    removePhoto(index){
     
     
      modalService.createModal(i18n.t('language.remove_for_upload')).then(
      ()=>{
      
       this.medias.splice(index,1);
       
      })

      
      
    }
    
  },
  /*
  watch:{
    medias:function(){
      // media list has been updated. scroll to end..
    }
  },
  */
  beforeDestroy(){
    
  },
  mounted(){
    
     //this.data_medias=this.medias;
    
  },


}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
